import React, { Component } from "react";
import { isMobile } from "react-device-detect";

import { GlobalConsumer } from "../../../context/GlobalContext";

import Api from "../../../lib/componentApi";
import getDefaultOptions from "../../../lib/getDefaultOptions";
import getAppErrors from "../../../lib/appErrors";
import getAppStrings from "../../../lib/appStrings";

import AppInfo from "../../Common/AppInfo";
import SubmitItemLoading from "../../Loadings/SubmitItem";
import AppErrors from "../../Common/AppErrors";
import getPictureUrl from "../../../lib/getPictureUrl";
import ItemImagePopup from "../components/Detail/ItemImage";

export default class AddItem extends Component {
  constructor(props) {
    super(props);
    const enabledOptions =
      (props.item.options &&
        props.item.options.length &&
        props.item.options.filter(option => option.enabled)) ||
      [];
    this.state = {
      quantity: 1,
      options: enabledOptions,
      defaultOption: enabledOptions[0],
      totalAmount: 0,
      selectedOptions: [],
      noteSection: props.item.noteAble && !enabledOptions.length,
      note: "",
      infoMessage: null,
      forceBasket: false,
      errorMessage: null,
      showItemImage: false,
      buttonLoading: false
    };
  }
  async componentDidMount() {
    const { item, onCloseItem } = this.props;
    const selectedOptions = await getDefaultOptions(item.options);
    this.setState({ selectedOptions }, () => {
      this.calculateItemsAmount(selectedOptions);
    });
    const popup = document.getElementById("popup-bg");

    if (popup) {
      popup.addEventListener("click", () => onCloseItem(null), false);
    }
  }

  handleItemCount = (event, type) => {
    event.preventDefault();
    const { quantity, selectedOptions } = this.state;
    if (type === "dec") {
      this.setState({ quantity: quantity - 1 }, () => {
        this.calculateItemsAmount(selectedOptions);
      });
    } else {
      this.setState({ quantity: quantity + 1 }, () => {
        this.calculateItemsAmount(selectedOptions);
      });
    }
  };
  calculateItemsAmount = options => {
    let { oldAmount, newAmount, freebie } = this.props.item;
    const { quantity } = this.state;
    if (quantity) {
      let valueAmount = 0;
      options.forEach(option => {
        option.values.forEach(value => {
          valueAmount += value.quantity * value.amount;
        });
      });
      let totalAmount;
      if (freebie) {
        let amount =
          parseFloat((oldAmount + valueAmount) * quantity) -
          parseFloat(oldAmount);
        totalAmount = amount.toFixed(2);
      } else {
        totalAmount = parseFloat((valueAmount + newAmount) * quantity).toFixed(
          2
        );
      }

      this.setState({
        totalAmount
      });
    }
  };
  handleNextExtra = event => {
    event.preventDefault();
    this.handleChangeTab();
  };
  renderOptionsSection = () => {
    const matchingOption = this.getMatchingOption();
    let optionValues =
      matchingOption && matchingOption.values && matchingOption.values.length;
    const { defaultOption, selectedOptions, minRequiredClass } = this.state;
    return (
      <div className="add-item-options white-bg">
        <h5
          className={(defaultOption.minRequired > 1 && minRequiredClass) || ""}
        >
          {(defaultOption.minRequired > 1 &&
            `Select ${defaultOption.minRequired} options...`) ||
            defaultOption.name}{" "}
        </h5>
        <ul>
          {(!defaultOption.required && !optionValues && (
            <li onClick={this.handleNextExtra} className="move-back">
              <a className="d-flex justify-content-between cursor-pointer">
                I dont want any {defaultOption.name.toLowerCase()}
                <icon className="icon icon-arrow-3" />
              </a>
            </li>
          )) || <noscript />}
          {defaultOption.values.length &&
            defaultOption.values
              .filter(value => value.enabled)
              .map(optionValue => {
                const selected = selectedOptions.find(
                  selectedOption => selectedOption.id === defaultOption.id
                );
                const multipleSelection = defaultOption.multipleSelection;
                const value =
                  selected &&
                  selected.values &&
                  selected.values.find(
                    selectedValue => selectedValue.id === optionValue.id
                  );
                const quantity = value && value.quantity;
                const singleQuantityAble = value && value.quantityAble === 1;
                const className = (quantity && "active") || "";
                return (
                  <li
                    className={className}
                    style={{ cursor: "pointer" }}
                    key={optionValue.id}
                    onClick={e => this.handleSelectValue(e, optionValue)}
                  >
                    <a
                      className="d-flex justify-content-between cursor-pointer"
                      value={optionValue.id}
                    >
                      {(quantity && <icon className="icon icon-okay-2" />) ||
                        (quantity && <p>{quantity}x</p>) || <noscript />}
                      {className && <icon className="icon icon-okay-2" />}
                      <p>{optionValue.name}</p>
                      {(optionValue.amount && (
                        <span>
                          +£{parseFloat(optionValue.amount).toFixed(2)}
                        </span>
                      )) || <noscript />}
                    </a>
                    <div className="d-flex align-items-center">
                      <div>
                        {(((!multipleSelection && quantity) ||
                          (!singleQuantityAble && quantity)) && (
                          <span
                            className="icon-trash-link"
                            onClick={e =>
                              this.handleRemoveValue(e, optionValue)
                            }
                          >
                            <icon className="icon icon-trash" />
                          </span>
                        )) || <noscript />}
                      </div>
                    </div>
                  </li>
                );
              })}
        </ul>
      </div>
    );
  };
  handleItemImagePopup = event => {
    const { showItemImage } = this.state;
    const mainDiv = document.getElementById("main-div");
    if (mainDiv && isMobile) {
      if (showItemImage) {
        mainDiv.classList.remove("body-overflow");
      } else {
        mainDiv.classList.add("body-overflow");
      }
      this.setState({
        showItemImage: !showItemImage
      });
    } else {
      event.preventDefault();
    }
  };
  renderItemQuantitySection = () => {
    const { quantity } = this.state;
    const { item } = this.props;
    const itemPicture = getPictureUrl(item.pictures, 500, 500);
    const isIncDisabled =
      item.quantityAble && item.quantityAble === parseInt(quantity);
    const isDecDisabled = quantity <= 1;

    return (
      <div className={`${itemPicture && "has-image"}`}>
        {itemPicture && (
          <div
            onClick={this.handleItemImagePopup}
            className="add-item-image"
            style={{ background: `url(${itemPicture}) no-repeat top center` }}
          />
        )}
        <div className="white-bg add-item-form">
          <p>{item.description}</p>
          <div className="add-item-input">
            <button
              disabled={isDecDisabled}
              onClick={e => this.handleItemCount(e, "dec")}
            >
              -
            </button>
            <span>{quantity}</span>
            <button
              disabled={isIncDisabled}
              onClick={e => this.handleItemCount(e, "inc")}
            >
              +
            </button>
          </div>
        </div>
      </div>
    );
  };
  renderTabsSection = () => {
    const { options, defaultOption } = this.state;
    return (
      <div>
        <ul className="white-bg add-item-extra">
          {options.map(option => {
            const className =
              (option.id === defaultOption.id && "active") || "";
            return (
              <li className={className} key={option.id}>
                <a
                  className="cursor-pointer"
                  onClick={() => this.handleChangeOptions(option.id)}
                >
                  {option.name}
                  <p>{this.getSelectedValue(option.id, option.name)}</p>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };
  renderNoteSection = () => {
    return (
      <div>
        <div className="white-bg add-item-note">
          <h5>Note for the restaurant</h5>
          <textarea
            id="note"
            onChange={this.handleChangeNote}
            placeholder="Extra sauce, no onions etc."
          />
        </div>
      </div>
    );
  };
  handleChangeNote = e => {
    e.preventDefault();
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleClickMinReq = minRequired => {
    if (minRequired) {
      this.setState({
        minRequiredClass: "error shake"
      });
    } else {
      this.handleChangeTab();
    }
  };
  renderTotalSection = updateBasket => {
    const {
      totalAmount,
      selectedOptions,
      defaultOption,
      noteSection,
      options,
      buttonLoading
    } = this.state;
    const { item } = this.props;

    if (item) {
      let button = {
        text: `Total (£${parseFloat(totalAmount).toFixed(2)})`,
        active: false,
        onClick: () => {
          this.handleClickMinReq(defaultOption.minRequired);
        }
      };

      const selectedOption = selectedOptions.find(
        option => option.id === defaultOption.id
      );

      const selectedOptionValuesLength =
        (selectedOption && this.getAllValuesQuantity(selectedOption.values)) ||
        0;

      if (defaultOption && defaultOption.minRequired) {
        if (selectedOptionValuesLength >= defaultOption.minRequired) {
          button = {
            text: `Next (£${parseFloat(totalAmount).toFixed(2)})`,
            active: true,
            onClick: () => {
              this.handleChangeTab();
            }
          };
        }
      } else {
        button = {
          text: `Next (£${parseFloat(totalAmount).toFixed(2)})`,
          active: true,
          onClick: () => {
            this.handleChangeTab();
          }
        };
      }

      if (item.noteAble) {
        if (noteSection) {
          button = {
            text: `Add to basket (£${parseFloat(totalAmount).toFixed(2)})`,
            active: true,
            onClick: () => {
              this.handleAddToBasket(updateBasket);
            }
          };
        }
      } else {
        let defaultOptionIndex;
        if (defaultOption) {
          defaultOptionIndex = this.getOptionIndex(
            item.options,
            defaultOption.id
          );
        } else {
          defaultOptionIndex = -1;
        }

        const lastOption = item.options.length - 1 === defaultOptionIndex;
        if (item.options && lastOption) {
          button = {
            text: `Add to basket (£${parseFloat(totalAmount).toFixed(2)})`,
            active: true,
            onClick: () => {
              this.handleAddToBasket(updateBasket);
            }
          };
        }
      }
      return (
        <div className="fixed-btn">
          {(options &&
            options.length &&
            options.length > 1 &&
            this.renderTabsSection()) || <noscript />}
          <button
            className={`add-btn btn btn-sign ${!button.active && "disabled"}`}
            onClick={button.onClick}
            disabled={buttonLoading}
          >
            <span>{button.text}</span>
          </button>
        </div>
      );
    } else {
      return <noscript />;
    }
  };
  getAllValuesQuantity = values => {
    let total = 0;

    if (values.length) {
      values.forEach(value => {
        total += value.quantity;
      });
    }
    return total;
  };
  handleSelectValue = (event, optionValue) => {
    event.preventDefault();
    const { defaultOption, selectedOptions } = this.state;
    const matchingOption = this.getMatchingOption();
    if (matchingOption) {
      selectedOptions.map(option => {
        if (option.id === defaultOption.id) {
          if (defaultOption.multipleSelection === 1) {
            const value =
              option.values.find(value => value.id === optionValue.id) || {};

            option.values = [
              {
                id: optionValue.id,
                quantity: value.quantity ? 0 : 1,
                amountEffectType: optionValue.amountEffectType,
                amount: optionValue.amount,
                name: optionValue.name,
                quantityAble: optionValue.quantityAble,
                restaurantItemOptionValueId: optionValue.id
              }
            ];
            return option;
          } else if (defaultOption.multipleSelection === 0) {
            if (
              option.values.filter(value => optionValue.id === value.id).length
            ) {
              option.values.map(value => {
                if (
                  value.id === optionValue.id &&
                  value.quantity < value.quantityAble
                ) {
                  value.quantity += 1;
                }
              });
              return option;
            } else {
              const value = {
                id: optionValue.id,
                quantity: 1,
                amountEffectType: optionValue.amountEffectType,
                amount: optionValue.amount,
                name: optionValue.name,
                quantityAble: optionValue.quantityAble,
                restaurantItemOptionValueId: optionValue.id
              };
              option.values.push(value);
              return option;
            }
          } else {
            if (
              option.values.filter(value => optionValue.id === value.id).length
            ) {
              if (optionValue.quantityAble === 1) {
                option.values.map(value => {
                  if (value.id === optionValue.id) {
                    if (value.quantity) {
                      value.quantity -= 1;
                    } else {
                      value.quantity += 1;
                    }
                  }
                  return value;
                });
              } else {
                option.values.map(value => {
                  if (value.id === optionValue.id) {
                    if (value.quantity < value.quantityAble) {
                      value.quantity += 1;
                    }
                  }
                  return value;
                });
              }

              return option;
            } else {
              const value = {
                id: optionValue.id,
                quantity: 1,
                amountEffectType: optionValue.amountEffectType,
                amount: optionValue.amount,
                name: optionValue.name,
                quantityAble: optionValue.quantityAble,
                restaurantItemOptionValueId: optionValue.id
              };
              option.values.push(value);
              return option;
            }
          }
          if (defaultOption.multipleSelection === 1) {
            this.handleChangeTab();
          }
        }
        if (
          option.values &&
          option.values.length >= defaultOption.minRequired
        ) {
          this.setState({ minRequiredClass: "" });
        }
      });
    } else {
      let option = {
        id: defaultOption.id,
        values: [
          {
            id: optionValue.id,
            quantity: 1,
            amountEffectType: optionValue.amountEffectType,
            amount: optionValue.amount,
            name: optionValue.name,
            quantityAble: optionValue.quantityAble,
            restaurantItemOptionValueId: optionValue.id
          }
        ]
      };
      selectedOptions.push(option);

      if (option.values && option.values.length >= defaultOption.minRequired) {
        this.setState({ minRequiredClass: "" });
      }

      if (defaultOption.multipleSelection === 1) {
        this.handleChangeTab();
      }
    }

    this.setState({
      selectedOptions
    });
    this.calculateItemsAmount(selectedOptions);
  };
  handleChangeTab = value => {
    const { item } = this.props;
    const { defaultOption, noteSection } = this.state;
    const optionIndex = this.getOptionIndex(item.options, defaultOption.id);
    let change = 1;
    if (value) change = value;
    if (noteSection && value) {
      const optionId =
        (item.options[item.options.length + change] &&
          item.options[item.options.length + change].id) ||
        "";
      if (optionId) {
        return this.handleChangeOptions(optionId);
      }
    }
    const nextOptionId =
      item.options[optionIndex + change] &&
      item.options[optionIndex + change].id;
    if (nextOptionId) {
      this.handleChangeOptions(nextOptionId);
    } else {
      if (!value && item.noteAble) {
        this.setState({ noteSection: true, minRequiredClass: "" });
      }
    }
  };
  handleRemoveValue = (event, optionValue) => {
    event.stopPropagation();
    let { selectedOptions, defaultOption } = this.state;
    let matchingOption = this.getMatchingOption();
    const values = matchingOption.values;
    let newValues = values.map(value => {
      if (value.id === optionValue.id && value.quantity) {
        value.quantity -= 1;
      }
      return value;
    });
    newValues = newValues.filter(value => value.quantity);
    matchingOption.values = newValues;

    let optionIndex = this.getOptionIndex(selectedOptions, defaultOption.id);
    selectedOptions[optionIndex] = matchingOption;
    this.setState(
      {
        selectedOptions
      },
      () => {
        this.calculateItemsAmount(selectedOptions);
      }
    );
  };
  getSelectedValue = (optionId, optionName) => {
    const { selectedOptions } = this.state;
    const selected = selectedOptions.find(option => option.id === optionId);
    if (selected && selected.values && selected.values.length) {
      if (selected.values.length > 1) {
        return `+${optionName}`;
      } else {
        return selected.values[0].name;
      }
    } else {
      return "";
    }
  };
  getOptionIndex = (options, optionId) => {
    return options.length ? options.findIndex(({ id }) => id === optionId) : -1;
  };
  handleChangeOptions = optionId => {
    const { item } = this.props;
    const { defaultOption, selectedOptions } = this.state;
    const selectedOption =
      selectedOptions.find(option => option.id === defaultOption.id) || null;
    const newOption = item.options.find(option => option.id === optionId);
    const selectedOptionValuesLength =
      (selectedOption && this.getAllValuesQuantity(selectedOption.values)) || 0;
    const defaultOptionIndex = this.getOptionIndex(
      item.options,
      defaultOption.id
    );
    const newOptionIndex = this.getOptionIndex(item.options, optionId);
    if (defaultOption.minRequired) {
      if (selectedOptionValuesLength >= defaultOption.minRequired) {
        this.setState({
          defaultOption: newOption,
          noteSection: false,
          minRequiredClass: ""
        });
      } else {
        if (
          defaultOptionIndex !== -1 &&
          newOptionIndex !== -1 &&
          newOptionIndex < defaultOptionIndex
        ) {
          this.setState({
            defaultOption: newOption,
            noteSection: false,
            minRequiredClass: ""
          });
        }
      }
    } else {
      this.setState({
        defaultOption: newOption,
        noteSection: false,
        minRequiredClass: ""
      });
    }
  };
  getMatchingOption = () => {
    let { selectedOptions, defaultOption } = this.state;
    return selectedOptions.find(
      selectedOption => selectedOption.id === defaultOption.id
    );
  };

  handleClearBasket = () => {
    const { infoMessage } = this.state;
    Api.post("/api/product/clear/basket", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response.code);
      } else {
        if (response.status) {
          console.log("basket cleared");
          if (infoMessage) {
            this.setState({ infoMessage: "" });
          }
        }
      }
    });
  };
  handleAddToBasket = (updateBasket, status) => {
    if (status && updateBasket) {
      updateBasket(null, true);
    }
    const { selectedOptions } = this.state;
    const { userAddress } = this.props;
    let options = [];
    for (let key in selectedOptions) {
      let obj = {};
      obj["restaurant_item_option_id"] = selectedOptions[key].id;
      obj["restaurant_item_option_values"] = selectedOptions[key].values || [];
      options.push(obj);
    }
    const addressId = (userAddress && userAddress.userAddressId) || 0;
    this.addBasket(addressId, options, updateBasket);
  };
  addBasket = (userAddressId, options, updateBasket) => {
    this.setState({ buttonLoading: true });
    const { quantity, note, forceBasket } = this.state;
    const { item, userAddress, onCloseItem, restaurantName } = this.props;
    const delivery =
      typeof userAddress.delivery === "boolean" ? userAddress.delivery : true;

    options = JSON.stringify(options);
    Api.post(
      "/api/product/item/basket",
      {
        itemId: item.id,
        quantity,
        options,
        delivery,
        note,
        userAddressId,
        forceBasket
      },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          if (response.code === 4020 || response.code === 4021) {
            const infoMessage = getAppStrings(4033);
            this.setState({
              infoMessage:
                (infoMessage &&
                  infoMessage.message &&
                  infoMessage.message.replace(
                    "[:par1]",
                    `${restaurantName}`
                  )) ||
                (errorMessage && errorMessage.message) ||
                response.message
            });
          } else {
            this.setState({
              errorMessage:
                (errorMessage && errorMessage.message) || response.message
            });
          }
        } else {
          if (response.status) {
            updateBasket(response.basket);
            onCloseItem(null, response.basket);
          } else {
            console.log(response, "status false add item");
          }
        }
        this.setState({ buttonLoading: false });
      }
    );
  };
  onClickClose = status => {
    const { onCloseItem } = this.props;
    if (status === "error") {
      this.setState(
        {
          errorMessage: null
        },
        () => {
          onCloseItem(null);
        }
      );
    } else {
      this.setState({
        infoMessage: null
      });
    }
  };
  onSubmitInfo = async updateBasket => {
    await this.handleClearBasket();
    await updateBasket(null, true);
    this.handleAddToBasket();
  };
  render() {
    const { item, onCloseItem, loading } = this.props;
    const {
      options,
      noteSection,
      defaultOption,
      infoMessage,
      errorMessage,
      showItemImage
    } = this.state;
    const canTurnBack =
      options && options.length && options[0].id !== defaultOption.id;
    const itemPicture = getPictureUrl(item.pictures, 500, 500);
    const buttonText = "Clear Basket";
    const title = "Start new order?";
    return (
      (item &&
        ((infoMessage && (
          <GlobalConsumer>
            {({ updateBasket }) => (
              <AppInfo
                message={infoMessage}
                title={title}
                onClickClose={() => this.onClickClose()}
                buttonText={buttonText}
                onSubmit={() => this.onSubmitInfo(updateBasket)}
              />
            )}
          </GlobalConsumer>
        )) ||
          (errorMessage && (
            <AppErrors
              message={errorMessage}
              onClickClose={() => this.onClickClose("error")}
            />
          )) || (
            <div>
              <div className="modal-bg" id="popup-bg" />
              <div className="modal" id="main-div">
                <div className="sign-page add-item-page">
                  {/* Header */}
                  <div className="head-general with-back">
                    <a
                      onClick={() => this.handleChangeTab(-1)}
                      className="back cursor-pointer"
                    >
                      {(canTurnBack && <img src="/png/chevron-left.png" />) || (
                        <noscript />
                      )}
                    </a>
                    <h4>{item.name}</h4>
                    <a
                      onClick={() => onCloseItem(null)}
                      className="close cursor-pointer"
                    >
                      <i className="icon icon-close" />
                    </a>
                  </div>
                  {/* Header */}
                  {showItemImage && (
                    <ItemImagePopup
                      imageSrc={itemPicture}
                      onClosePopup={this.handleItemImagePopup}
                    />
                  )}
                  {(loading && <SubmitItemLoading />) || <noscript />}
                  <div className="modal-body no-scroll">
                    <div className="add-item-scroll">
                      {this.renderItemQuantitySection()}

                      {(noteSection && this.renderNoteSection()) || (
                        <div>
                          {(options &&
                            options.length &&
                            this.renderOptionsSection()) || <noscript />}
                        </div>
                      )}
                    </div>
                    <GlobalConsumer>
                      {({ updateBasket }) =>
                        this.renderTotalSection(updateBasket)
                      }
                    </GlobalConsumer>
                  </div>
                </div>
                {/* .add-item-page */}
              </div>
              {/* .modal */}
            </div>
          ))) || <SubmitItemLoading />
    );
  }
}
